import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { authApi, errMsg } from "../api";
import { FormField, PrimaryButton } from "../components/FormField";
import { SquareParking } from "lucide-react";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [values, setValues] = useState({ password: "", confirm: "" });
  const [busy, setBusy] = useState(false);
  const set = (key, value) => setValues((v) => ({ ...v, [key]: value }));

  const submit = async (e) => {
    e.preventDefault();
    if (values.password !== values.confirm) {
      toast.error("Passwords do not match");
      return;
    }
    setBusy(true);
    try {
      await authApi.resetPassword({ token, password: values.password });
      toast.success("Password updated — please sign in");
      navigate("/");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center px-4" data-testid="reset-password-page">
      <div className="w-full max-w-md p-8 border border-[#262626] bg-[#141414] flex flex-col gap-6">
        <div className="flex items-center gap-3">
          <img src="/firstmed-logo.png" alt="FirstMed Ambulance" className="h-9 w-auto" />
          <SquareParking className="w-6 h-6 text-[#007AFF]" />
          <h1 className="text-2xl font-black tracking-tighter">LOT CONTROL</h1>
        </div>
        {token ? (
          <form onSubmit={submit} className="flex flex-col gap-4">
            <h2 className="text-lg font-semibold">Choose a new password</h2>
            <FormField
              label="New Password"
              type="password"
              required
              data-testid="reset-password-input"
              value={values.password}
              onChange={(e) => set("password", e.target.value)}
              placeholder="At least 8 characters"
            />
            <FormField
              label="Confirm Password"
              type="password"
              required
              data-testid="reset-password-confirm-input"
              value={values.confirm}
              onChange={(e) => set("confirm", e.target.value)}
              placeholder="Repeat new password"
            />
            <PrimaryButton type="submit" data-testid="reset-password-submit-btn" disabled={busy}>
              Update Password
            </PrimaryButton>
          </form>
        ) : (
          <p className="text-sm text-[#A3A3A3]" data-testid="reset-token-missing">
            This reset link is missing its token. Request a new link from the sign-in screen.
          </p>
        )}
        <button
          type="button"
          data-testid="reset-back-home-btn"
          onClick={() => navigate("/")}
          className="text-sm text-[#A3A3A3] hover:text-[#F5F5F5] transition-colors self-start"
        >
          Back to the lot
        </button>
      </div>
    </div>
  );
}
